

<ion-content  overflow-scroll="false" scrollY=true class="body normal">
  <ion-header>  <ion-title>About</ion-title></ion-header>
  


  <ion-item class="normal">
   <ion-label>App Version </ion-label>
 <ion-label *ngIf='appConfig.appInfo' slot=end> {{appConfig.appInfo.version}} </ion-label>
 </ion-item>
<ion-item class="normal">
   <ion-label>App Build </ion-label>
 <ion-label *ngIf='appConfig.appInfo' slot=end> {{appConfig.appInfo.build}} </ion-label>
 </ion-item>
 <ion-item><ion-button (click)='done()' > Done</ion-button></ion-item>
 
 
</ion-content>
